import { createResponsiveType, baseTheme } from '@moonpig/launchpad-theme-common';
export * from '@moonpig/launchpad-theme-common';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { ColorPrimary01, ColorPrimary02, ColorPrimary03, ColorBlack00, ColorBlack05, ColorBlack10, ColorBlack20, ColorBlack30, ColorBlack40, ColorBlack50, ColorBlack60, ColorBlack70, ColorBlack80, ColorBlack90, ColorBlack100, ColorTextHeadline, ColorTextBody, ColorTextInverted, ColorTextAlternate, ColorTextLabel, ColorInteractionButton, ColorInteractionButtonHover, ColorInteractionButtonFocus, ColorInteractionControl, ColorInteractionDeactivated, ColorInteractionFocusIndicator, ColorInteractionIcon, ColorInteractionIconHover, ColorInteractionLoading, ColorInteractionSelectedState, ColorInteractionTextLink, ColorInteractionTextLinkHover, ColorInteractionTextLinkFocus, ColorFeedbackSuccess, ColorFeedbackError, ColorFeedbackInformation, ColorFeedbackWarning, ColorFeedbackRating, ColorBackgroundSelectedState, ColorBackgroundSuccess, ColorBackgroundDeactivated, ColorBackgroundError, ColorBackgroundInformation, ColorBackgroundWarning, ColorBackground01, ColorBackground02, ColorBackground03, ColorBackground04, ColorBackground05, ColorBackground06, ColorBackground07, ColorBackgroundHero, ColorBackgroundBranded, ColorBackgroundSite, ColorBorder01, ColorBorder02, ColorBorder03, ColorBorder04, TypeMobileDisplay01, TypeDesktopDisplay01, TypeMobileDisplay02, TypeDesktopDisplay02, TypeMobileDisplay03, TypeDesktopDisplay03, TypeMobileDisplay04, TypeDesktopDisplay04, TypeMobileDisplay05, TypeDesktopDisplay05, TypeMobileDisplay06, TypeDesktopDisplay06, TypeMobileBodyLead, TypeDesktopBodyLead, TypeMobileBodyText, TypeDesktopBodyText, TypeMobileBodyCaption, TypeDesktopBodyCaption, TypeMobileBodyLabel, TypeDesktopBodyLabel, TypeMobileButtonLabel, TypeDesktopButtonLabel, TypeMobileButtonUnderlined, TypeDesktopButtonUnderlined, TypeMobileButtonTextLink, TypeDesktopButtonTextLink } from '@moonpig/launchpad-design-tokens/mission-control';

var colors = {
  colorPrimary01: ColorPrimary01,
  colorPrimary02: ColorPrimary02,
  colorPrimary03: ColorPrimary03,
  colorBlack00: ColorBlack00,
  colorBlack05: ColorBlack05,
  colorBlack10: ColorBlack10,
  colorBlack20: ColorBlack20,
  colorBlack30: ColorBlack30,
  colorBlack40: ColorBlack40,
  colorBlack50: ColorBlack50,
  colorBlack60: ColorBlack60,
  colorBlack70: ColorBlack70,
  colorBlack80: ColorBlack80,
  colorBlack90: ColorBlack90,
  colorBlack100: ColorBlack100,
  colorTextHeadline: ColorTextHeadline,
  colorTextBody: ColorTextBody,
  colorTextInverted: ColorTextInverted,
  colorTextAlternate: ColorTextAlternate,
  colorTextLabel: ColorTextLabel,
  colorInteractionButton: ColorInteractionButton,
  colorInteractionButtonHover: ColorInteractionButtonHover,
  colorInteractionButtonFocus: ColorInteractionButtonFocus,
  colorInteractionControl: ColorInteractionControl,
  colorInteractionDeactivated: ColorInteractionDeactivated,
  colorInteractionFocusIndicator: ColorInteractionFocusIndicator,
  colorInteractionIcon: ColorInteractionIcon,
  colorInteractionIconHover: ColorInteractionIconHover,
  colorInteractionLoading: ColorInteractionLoading,
  colorInteractionSelectedState: ColorInteractionSelectedState,
  colorInteractionTextLink: ColorInteractionTextLink,
  colorInteractionTextLinkHover: ColorInteractionTextLinkHover,
  colorInteractionTextLinkFocus: ColorInteractionTextLinkFocus,
  colorFeedbackSuccess: ColorFeedbackSuccess,
  colorFeedbackError: ColorFeedbackError,
  colorFeedbackInformation: ColorFeedbackInformation,
  colorFeedbackWarning: ColorFeedbackWarning,
  colorFeedbackRating: ColorFeedbackRating,
  colorBackgroundSelectedState: ColorBackgroundSelectedState,
  colorBackgroundSuccess: ColorBackgroundSuccess,
  colorBackgroundDeactivated: ColorBackgroundDeactivated,
  colorBackgroundError: ColorBackgroundError,
  colorBackgroundInformation: ColorBackgroundInformation,
  colorBackgroundWarning: ColorBackgroundWarning,
  colorBackground01: ColorBackground01,
  colorBackground02: ColorBackground02,
  colorBackground03: ColorBackground03,
  colorBackground04: ColorBackground04,
  colorBackground05: ColorBackground05,
  colorBackground06: ColorBackground06,
  colorBackground07: ColorBackground07,
  colorBackgroundHero: ColorBackgroundHero,
  colorBackgroundBranded: ColorBackgroundBranded,
  colorBackgroundSite: ColorBackgroundSite,
  colorBorder01: ColorBorder01,
  colorBorder02: ColorBorder02,
  colorBorder03: ColorBorder03,
  colorBorder04: ColorBorder04
};

var typography = {
  // top level tokens
  typeMobileDisplay01: TypeMobileDisplay01,
  typeDesktopDisplay01: TypeDesktopDisplay01,
  typeMobileDisplay02: TypeMobileDisplay02,
  typeDesktopDisplay02: TypeDesktopDisplay02,
  typeMobileDisplay03: TypeMobileDisplay03,
  typeDesktopDisplay03: TypeDesktopDisplay03,
  typeMobileDisplay04: TypeMobileDisplay04,
  typeDesktopDisplay04: TypeDesktopDisplay04,
  typeMobileDisplay05: TypeMobileDisplay05,
  typeDesktopDisplay05: TypeDesktopDisplay05,
  typeMobileDisplay06: TypeMobileDisplay06,
  typeDesktopDisplay06: TypeDesktopDisplay06,
  typeMobileBodyLead: TypeMobileBodyLead,
  typeDesktopBodyLead: TypeDesktopBodyLead,
  typeMobileBodyText: TypeMobileBodyText,
  typeDesktopBodyText: TypeDesktopBodyText,
  typeMobileBodyCaption: TypeMobileBodyCaption,
  typeDesktopBodyCaption: TypeDesktopBodyCaption,
  typeMobileBodyLabel: TypeMobileBodyLabel,
  typeDesktopBodyLabel: TypeDesktopBodyLabel,
  typeMobileButtonLabel: TypeMobileButtonLabel,
  typeDesktopButtonLabel: TypeDesktopButtonLabel,
  typeMobileButtonUnderlined: TypeMobileButtonUnderlined,
  typeDesktopButtonUnderlined: TypeDesktopButtonUnderlined,
  typeMobileButtonTextLink: TypeMobileButtonTextLink,
  typeDesktopButtonTextLink: TypeDesktopButtonTextLink,
  // responsive types
  typeDisplay01: createResponsiveType({
    xs: TypeMobileDisplay01,
    md: TypeDesktopDisplay01
  }),
  typeDisplay02: createResponsiveType({
    xs: TypeMobileDisplay02,
    md: TypeDesktopDisplay02
  }),
  typeDisplay03: createResponsiveType({
    xs: TypeMobileDisplay03,
    md: TypeDesktopDisplay03
  }),
  typeDisplay04: createResponsiveType({
    xs: TypeMobileDisplay04,
    md: TypeDesktopDisplay04
  }),
  typeDisplay05: createResponsiveType({
    xs: TypeMobileDisplay05,
    md: TypeDesktopDisplay05
  }),
  typeDisplay06: createResponsiveType({
    xs: TypeMobileDisplay06,
    md: TypeDesktopDisplay06
  }),
  typeBodyLead: createResponsiveType({
    xs: TypeMobileBodyLead,
    md: TypeDesktopBodyLead
  }),
  typeBodyText: createResponsiveType({
    xs: TypeMobileBodyText,
    md: TypeDesktopBodyText
  }),
  typeBodyCaption: createResponsiveType({
    xs: TypeMobileBodyCaption,
    md: TypeDesktopBodyCaption
  }),
  typeBodyLabel: createResponsiveType({
    xs: TypeMobileBodyLabel,
    md: TypeDesktopBodyLabel
  }),
  typeButtonLabel: createResponsiveType({
    xs: TypeMobileButtonLabel,
    md: TypeDesktopButtonLabel
  }),
  typeButtonUnderlined: createResponsiveType({
    xs: TypeMobileButtonUnderlined,
    md: TypeDesktopButtonUnderlined
  }),
  typeButtonTextLink: createResponsiveType({
    xs: TypeMobileButtonTextLink,
    md: TypeDesktopButtonTextLink
  })
};

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var theme = _objectSpread(_objectSpread({}, baseTheme), {}, {
  colors: colors,
  // Nb. @material-ui/system currently looks for 'palette' on theme
  // This may change in https://github.com/mui-org/material-ui/issues/13663
  // at which point we could drop this alias
  palette: colors,
  typography: typography
});

export { theme, theme as themeDark };
